import BaseFilter from './BaseFilter';
import { requestGetPackageIds as request } from '../../../state/ducks/filters/api';

const PackageIdFilter = ({ value, requestQueryParams, onChange }) => BaseFilter({ value, onChange, request, requestQueryParams });

PackageIdFilter.defaultProps = BaseFilter.defaultProps;

export default PackageIdFilter;
